<template>
  <div class="c-overseas-wrapper">
    <overseas-filter
      ref="filter"
      slot="filter"
      :game-data="groupGames"
      :operator-data="operatorData"
      :designer-data="designerData"
      :scheme-data="schemeData"
      :account-data="accountData"
      :tag-data="tagData"
      :counties="counties"
      :material-data="materialData"
      @on-change="filterData"
    />
    <div class="c-contorl-btn">
      <div class="c-show-switch">
        <span>仅显示有数据素材</span>
        <i-Switch v-model="status" :true-value="1" :false-value="0" />
      </div>

      <DateRangePicker v-model="datetime" :clearable="false" style="width: 220px; margin-right: 3px"></DateRangePicker>

      <Button icon="md-download" @click="downData">数据导出</Button>
      <Button @click="modalColumn = true">自定义列</Button>
    </div>

    <Viewport v-model="tableHeight">
      <el-table
        ref="overseasTable"
        class="common-el-table-styles summary-el-table-styles"
        :data="tableData"
        :height="tableHeight"
        :loading="loading"
        :summary="summaries"
        border
        show-summary
        @on-sort="sortTable"
        @header-dragend="headerDragend"
      >
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id + col.key"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
          :sortable="col.sortable"
          :sort-orders="['descending', 'ascending', null]"
        >
          <template slot-scope="scope">
            <template v-if="col.key === 'content'">
              <a-image
                v-if="scope.row.coverUrl"
                :src="scope.row.coverUrl"
                :width="100"
                :video="scope.row.type === 'VIDEO'"
                hide-video
                :row="scope.row"
                @on-click="showMedia"
              />
              <el-button type="text" v-else-if="scope.row.videoUrl" @click="handleGG(scope.row.videoUrl)">视频链接</el-button>
              <span v-else-if="scope.row.text">{{ scope.row.text }}</span>
              <span v-else></span>
            </template>
            <span v-else-if="towThousand.includes(col.key)">{{ scope.row[col.key] | toThousands }}</span>
            <span v-else-if="twoDecimal.includes(col.key)">{{ scope.row[col.key] | toPercentFixed }}</span>
            <span v-else-if="col.key === 'type'">{{ toType(scope.row[col.key]) }}</span>
            <el-button type="text" v-else-if="col.key === 'name'" @click="handleShow(scope.row)">
              {{ isEmpty(scope.row[col.key]) ? '-' : scope.row[col.key] }}
            </el-button>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="tableColumns" :subTitle="['基础数据']" @on-select="selectCustomColumn" />
  </div>
</template>
<script>
import moment from 'moment'
import { HOST_API } from '@/api/config'
import { isArray, isEmpty, deepCopy, throttle } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'

import mixinTable from '../materials/mixin_table'
import tableColumns from '../data/overseas_column'
import OverseasFilter from './components/overseas-filter.vue'

import CustomColumn from '@/components/converter/custom-column.vue'
import DateRangePicker from '@/components/date-range-picker'

import { getGameGroupTree, adAccount, getSysMember, getSysTag } from '@/api/common.model'
import { getOverseasPage, getOverseasCountry } from '@/api/report.model'

const now = moment().format('YYYY-MM-DD')
const start = moment().startOf('month').format('YYYY-MM-DD')
const twoDecimal = ['ctr', 'cvr', 'roi', 'over2sPlay', 'over25Play', 'over3sPlay', 'over50Play', 'over100Play']
const towThousand = ['amount', 'pv', 'clickNum', 'downNum', 'cpi', 'payNum', 'payMoney', 'totalPlay']
const materialData = [
  { id: 'IMAGE', name: '图片' },
  { id: 'VIDEO', name: '视频' },
  { id: 'TEXT', name: '标题' },
  { id: 'DESCRIPTION', name: '描述' },
  { id: 'NONE', name: '无' }
]
export default {
  name: 'OverseasList',
  mixins: [mixinTable],
  components: { OverseasFilter, CustomColumn, DateRangePicker },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => !ret.show)
    }
  },
  watch: {
    tableColumns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage('OverseasCustomColumn', show)
        this.$nextTick(() => {
          this.$refs.overseasTable && this.$refs.overseasTable.doLayout()
        })
      },
      deep: true
    },
    datetime: {
      handler() {
        throttle(() => {
          this.pageIndex = 1
          if (this.params) this.$refs.filter.sendEvent()
          else this.getData({})
        }, 600)()
      },
      deep: true
    },
    status() {
      this.pageIndex = 1
      this.$refs.filter.sendEvent()
    }
  },
  data() {
    return {
      datetime: [],
      twoDecimal,
      towThousand,
      materialData,
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      sumdata: [], // 合计数据
      groupGames: [],
      operatorData: [], // 管理人员
      designerData: [], // 设计人员
      schemeData: [], // 策划人员
      accountData: [],
      tagData: [],
      counties: [], // 国家代码表
      status: 1 // 是否显示有数据素材
    }
  },
  methods: {
    isEmpty,
    getData(filter) {
      if (!isArray(this.datetime) || !this.datetime.length) return
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        sort: this.sort,
        order: this.order,
        status: this.status
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getOverseasPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info, sum_data } = data
            if (isArray(list) && page_info && sum_data) {
              const { total_number } = page_info
              this.sumdata = sum_data
              this.initTableColumns()
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
            this.$nextTick(() => {
              this.$refs.overseasTable && this.$refs.overseasTable.doLayout()
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('OverseasCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        this.tableColumns = tableColumns
          .sort((a, b) => {
            const idxA = shows.findIndex((ret) => ret.includes(a.key))
            const idxB = shows.findIndex((ret) => ret.includes(b.key))
            const sortA = idxA < 0 ? idxA : shows.length - idxA
            const sortB = idxB < 0 ? idxB : shows.length - idxB
            return sortB - sortA
          })
          .map((ret) => {
            const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
            ret.show = !shows
              .filter((met) => met)
              .map((met) => (met.includes('|') ? met.split('|').shift() : met))
              .includes(ret.key)
            shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
            return ret
          })
      } else this.tableColumns = [...tableColumns]
    },
    downData() {
      let url = `${HOST_API}/api/ptom/overseas/downReport`
      url += `?sessionid=${this.$store.state.token}&type=1`
      url += `&beginTime=${this.params.beginTime}`
      url += `&endTime=${this.params.endTime}`
      url += `&status=${this.status}`
      this.params.platformStr && (url += `&platformStr=${this.params.platformStr}`)
      this.params.mediaIdStr && (url += `&mediaIdStr=${this.params.mediaIdStr}`)
      this.params.siteSetStr && (url += `&siteSetStr=${this.params.siteSetStr}`)
      this.params.imgTypesStr && (url += `&imgTypesStr=${this.params.imgTypesStr}`)
      this.params.adAccountIdStr && (url += `&adAccountIdStr=${this.params.adAccountIdStr}`)
      this.params.gameIdStr && (url += `&gameIdStr=${this.params.gameIdStr}`)
      this.params.labelIdsStr && (url += `&labelIdsStr=${this.params.labelIdsStr}`)
      this.params.opIdsStr && (url += `&opIdsStr=${this.params.opIdsStr}`)
      this.params.plannerIdStr && (url += `&plannerIdStr=${this.params.plannerIdStr}`)
      this.params.designerIdStr && (url += `&designerIdStr=${this.params.designerIdStr}`)
      this.params.countrysStr && (url += `&countrysStr=${this.params.countrysStr}`)
      this.params.uploadBeginTime && (url += `&uploadBeginTime=${this.params.uploadBeginTime}`)
      this.params.uploadEndTime && (url += `&uploadEndTime=${this.params.uploadEndTime}`)
      this.params.keyword && (url += `&keyword=${encodeURIComponent(this.params.keyword)}`)
      this.order && (url += `&order=${this.order}`)
      this.sort && (url += `&sort=${this.sort}`)
      window.open(url)
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (twoDecimal.includes(prop)) sums[index] = toPercentFixed(val)
        else if (towThousand.includes(prop)) sums[index] = toThousands(val)
        else sums[index] = ''
      })
      return sums
    },
    headerDragend({ n, column }) {
      const index = this.tableColumns.findIndex((ret) => ret.key === column.property)
      index > -1 && this.$set(this.tableColumns[index], 'width', n)
    },
    selectCustomColumn(params) {
      const tableColumns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'tableColumns', tableColumns)
      this.modalColumn = false
    },
    toType(cellValue) {
      const index = this.materialData.findIndex((ret) => ret.id === cellValue)
      if (index < 0) return '未知'
      else return this.materialData[index].name
    },
    handleShow(row) {
      if (!isArray(this.datetime) || !this.datetime.length || !row) return
      throttle(() => {
        const { imageId, mediaId, name, type } = row
        const query = { imageId, mediaId, name, type: this.toType(type), beginTime: this.datetime[0], endTime: this.datetime[1] }
        this.$router.push({ name: 'overseasdetail', query })
      }, 600)()
    },
    showMedia(param) {
      const { src, video, row } = param
      const { videoUrl, coverUrl } = row
      const imgs = coverUrl.includes(',') ? coverUrl.split(',') : [coverUrl]
      this.$Gallery.open({ src, video, videoUrl, imgs })
    },
    handleGG(url) {
      window.open(url)
    },
    preloadData() {
      Promise.all([
        getGameGroupTree(),
        adAccount({ authFlag: 1, mediaIds: [181, 159, 96] }),
        getSysMember(),
        getSysTag(),
        getOverseasCountry()
      ]).then((data) => {
        const [groupData, accountData, operatorData, tagData, counties] = data
        if (isArray(groupData)) {
          this.groupGames = groupData.map((ret) => {
            const obj = { id: ret.gameGroupId, name: ret.gameGroupName }
            if (isArray(ret.children)) {
              Object.assign(obj, {
                children: ret.children
                  .filter((met) => met.gameName)
                  .map((met) => {
                    return { id: met.gameId, name: met.gameName }
                  })
              })
            }
            return obj
          })
        }
        if (isArray(operatorData)) {
          this.operatorData = deepCopy(operatorData)
          this.designerData = deepCopy(operatorData)
          this.schemeData = deepCopy(operatorData)
        }
        isArray(accountData) && (this.accountData = accountData)
        isArray(tagData) &&
          (this.tagData = tagData.map((ret) => {
            return { id: ret.labelId, name: ret.content, labelType: ret.labelType }
          }))
        isArray(counties) && (this.counties = counties)
      })
    }
  },
  created() {
    this.datetime = [start, now]
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-overseas-wrapper {
  height: 100%;

  .c-contorl-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 8px;

    .c-show-switch {
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-right: 3px;

      span {
        padding: 0 3px;
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
